import { formatMoney } from "@hakili/i18n";

/**
 * `P0-UIK-005`: the only way a figure in FCFA reaches a screen.
 *
 * **Danger sentence.** A price rendered by hand is a price formatted by
 * whoever wrote that line: one screen writes `1 500 000 FCFA` with a plain
 * space, another `1500000`, a third `1 500 000,00`. The bank sees three
 * products. This component exists so there is exactly one answer, and
 * `hakili/no-raw-figure` exists so nobody can write a fourth.
 *
 * `tabular-nums` is 6.5.2's own row, and it is load-bearing rather than
 * decorative: without it a column of amounts in a proportional font does not
 * line up on its digits, and a reader comparing two rows compares their
 * widths instead of their values.
 */
export interface MoneyProps {
  /** FCFA, an integer. `Money` from `platform` where it comes from a domain. */
  readonly amount: number;
  /** Reserved for a balance movement, where the sign carries meaning. */
  readonly className?: string;
}

export function Money({ amount, className }: MoneyProps): React.JSX.Element {
  return (
    <span className={className === undefined ? "tabular-nums" : `tabular-nums ${className}`}>
      {formatMoney(amount)}
    </span>
  );
}
